<login-form
  [scope]="currentScope"
  [scopeLabelKey]="currentScopeLabel"
  (userData)="login($event)"
  (scopeSubmit)="navigate($event)"
></login-form>
